/**
 * Collection filters: collapsible groups (localStorage persisted),
 * show-more within groups, AJAX filter updates, price-chip shortcuts, sort.
 */
(function () {
  var sidebar = document.getElementById('collection-sidebar');
  var main = document.querySelector('[data-collection-main]');
  if (!sidebar || !main) return;

  var collectionHandle = sidebar.dataset.collectionHandle || 'default';
  var storageKey = 'richard_filter_state_' + collectionHandle;

  /* ── Collapse state (persisted) ── */
  function readState() {
    try { return JSON.parse(localStorage.getItem(storageKey) || '{}'); } catch (_) { return {}; }
  }
  function writeState(state) {
    if (!window.RichardConsent || !window.RichardConsent.has('functional')) return;
    try { localStorage.setItem(storageKey, JSON.stringify(state)); } catch (_) {}
  }

  function bindGroupToggles() {
    var state = readState();
    sidebar.querySelectorAll('[data-filter-group]').forEach(function (group) {
      var key = group.dataset.filterKey;
      var btn = group.querySelector('[data-filter-toggle-btn]');
      var body = group.querySelector('.filter-group__body');
      if (!btn || !body) return;

      // Apply persisted state if present
      if (Object.prototype.hasOwnProperty.call(state, key)) {
        var open = state[key];
        body.hidden = !open;
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      }

      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        var next = !open;
        btn.setAttribute('aria-expanded', next ? 'true' : 'false');
        body.hidden = !next;
        var s = readState();
        s[key] = next;
        writeState(s);
      });
    });
  }

  /* ── Show more within a group ── */
  function bindShowMore() {
    sidebar.querySelectorAll('[data-filter-show-more]').forEach(function (btn) {
      var textEl = btn.querySelector('[data-filter-show-more-text]');
      var expanded = false;
      btn.addEventListener('click', function () {
        expanded = !expanded;
        var group = btn.closest('.filter-group');
        if (!group) return;
        group.querySelectorAll('.filter-option--extra').forEach(function (el) {
          el.hidden = !expanded;
        });
        if (textEl) {
          if (expanded) {
            textEl.textContent = btn.getAttribute('data-label-less') || 'Show less';
          } else {
            var count = group.querySelectorAll('.filter-option').length;
            var moreTpl = btn.getAttribute('data-label-more') || 'Show all (%count%)';
            textEl.textContent = moreTpl.replace('%count%', count);
          }
        }
      });
    });
  }

  /* ── Price chip shortcuts ── */
  function bindPriceChips() {
    sidebar.querySelectorAll('[data-filter-price]').forEach(function (chip) {
      chip.addEventListener('click', function () {
        var range = chip.dataset.filterPrice; // e.g. "10000-30000" or "80000-"
        var parts = range.split('-');
        var min = parts[0] ? parseInt(parts[0], 10) / 100 : '';
        var max = parts[1] ? parseInt(parts[1], 10) / 100 : '';
        var priceForm = chip.closest('form');
        if (!priceForm) return;
        var inputs = priceForm.querySelectorAll('input[type="number"]');
        if (inputs[0]) inputs[0].value = min;
        if (inputs[1]) inputs[1].value = max;
        triggerUpdate();
      });
    });
  }

  /* ── AJAX filter updates ── */
  var updateTimer = null;
  function bindAjaxUpdates() {
    sidebar.querySelectorAll('[data-filter-form]').forEach(function (form) {
      form.addEventListener('change', function () {
        clearTimeout(updateTimer);
        updateTimer = setTimeout(triggerUpdate, 250);
      });
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        triggerUpdate();
      });
    });

    // Sort dropdown
    var sortSelect = document.querySelector('[data-collection-sort]');
    if (sortSelect) {
      sortSelect.addEventListener('change', triggerUpdate);
    }

    // Intercept "Clear all" + individual chip removes → AJAX instead of nav
    document.addEventListener('click', function (e) {
      var a = e.target.closest('.filter-active__tag, .filter-active__clear');
      if (!a) return;
      var href = a.getAttribute('href');
      if (!href) return;
      e.preventDefault();
      history.replaceState(null, '', href);
      fetchAndSwap(href);
    });
  }

  function buildQuery() {
    var params = new URLSearchParams();
    // Sort
    var sortSelect = document.querySelector('[data-collection-sort]');
    if (sortSelect && sortSelect.value) params.set('sort_by', sortSelect.value);

    // All filter inputs (checkboxes + price fields)
    sidebar.querySelectorAll('[data-filter-input]').forEach(function (input) {
      if (input.type === 'checkbox') {
        if (input.checked) params.append(input.name, input.value);
      } else if (input.type === 'number') {
        if (input.value !== '' && !isNaN(parseFloat(input.value))) {
          params.append(input.name, (parseFloat(input.value) * 100).toString());
        }
      }
    });

    return params.toString();
  }

  function triggerUpdate() {
    var qs = buildQuery();
    var base = sidebar.dataset.collectionHandle
      ? '/collections/' + sidebar.dataset.collectionHandle
      : window.location.pathname;
    var newUrl = qs ? base + '?' + qs : base;
    history.replaceState(null, '', newUrl);
    fetchAndSwap(newUrl);
  }

  function fetchAndSwap(url) {
    main.classList.add('is-loading');
    var sectionId = document.querySelector('[data-collection-section-id]');
    // Try fetching the URL and extracting the <main> or relevant pieces
    fetch(url, { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newMain = doc.querySelector('[data-collection-main]');
        var newSidebar = doc.querySelector('#collection-sidebar .filter-groups');
        var newActive = doc.querySelectorAll('[data-active-filters]');

        // replaceChildren moves parsed nodes directly — no string round-trip,
        // no re-parsing. Safer than `el.innerHTML = otherEl.innerHTML`.
        if (newMain) {
          main.replaceChildren.apply(main, Array.from(newMain.children));
        }
        if (newSidebar) {
          var currentSidebar = document.querySelector('#collection-sidebar .filter-groups');
          if (currentSidebar) {
            currentSidebar.replaceChildren.apply(currentSidebar, Array.from(newSidebar.children));
          }
        }

        // Rebind all handlers on new DOM
        bindGroupToggles();
        bindShowMore();
        bindPriceChips();
        bindAjaxUpdates();

        // Update active-count badge
        var activeCount = document.querySelectorAll('#collection-sidebar [data-active-filter]').length;
        var badge = document.querySelector('[data-active-count]');
        var title = document.querySelector('.collection-sidebar__title');
        if (badge) {
          if (activeCount > 0) {
            badge.textContent = activeCount;
            badge.hidden = false;
          } else {
            badge.hidden = true;
          }
        } else if (activeCount > 0 && title) {
          var s = document.createElement('span');
          s.className = 'collection-sidebar__count';
          s.dataset.activeCount = '';
          s.textContent = activeCount;
          title.appendChild(s);
        }

        main.classList.remove('is-loading');
        // Scroll product grid into view (respect reduced-motion preference)
        var grid = main.querySelector('[data-product-grid]');
        if (grid && window.scrollY > grid.offsetTop) {
          var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          window.scrollTo({ top: grid.offsetTop - 80, behavior: reducedMotion ? 'auto' : 'smooth' });
        }
      })
      .catch(function (err) {
        console.error('Filter update error:', err);
        main.classList.remove('is-loading');
      });
  }

  /* ── Init ── */
  bindGroupToggles();
  bindShowMore();
  bindPriceChips();
  bindAjaxUpdates();
})();
